export default {
    rules : {
        'pfizer.com': '/pfizer-saml/login',
        'colpal.com': '/colgate-saml/login',
        'hillspet.com': '/colgate-saml/login',
        'hello-products.com': '/colgate-saml/login',
        'filorga.com': '/colgate-saml/login',
        'pcaskin.com': '/colgate-saml/login',
        'travelers.com' : '/travelers-saml/login'
    },

    exceptions: [
        'emtech@pfizer.com'
    ]
};
